var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionFillIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.418V5.66797C16.6667 4.26784 16.6667 3.56777 16.3942 3.03299C16.1545 2.56259 15.772 2.18014 15.3016 1.94045C14.7669 1.66797 14.0668 1.66797 12.6667 1.66797H7.33333C5.9332 1.66797 5.23314 1.66797 4.69836 1.94045C4.22795 2.18014 3.8455 2.56259 3.60582 3.03299C3.33333 3.56777 3.33333 4.26784 3.33333 5.66797V14.3346C3.33333 15.7348 3.33333 16.4348 3.60582 16.9696C3.8455 17.44 4.22795 17.8225 4.69836 18.0622C5.23314 18.3346 5.9332 18.3346 7.33333 18.3346H10M11.6667 9.16797H6.66667M8.33333 12.5013H6.66667M13.3333 5.83464H6.66667M12.0833 15.8346L13.75 17.5013L17.5 13.7513",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionFillIn);
export default __webpack_public_path__ + "static/media/action-fill-in.72525c9bc94201c930f51b500c71596d.svg";
export { ForwardRef as ReactComponent };